module.exports = __webpack_public_path__ + "img/73200.6af27c8b.jpg";